import * as constants from "../stores/constants";

/**
 * @param {Object} mousePos
 * @param {Object} dragging
 */
export var setDragProgress = function setDragProgress(mousePos, dragging) {
  return {
    type: constants.SET_DRAG_PROGRESS,
    mousePos: mousePos,
    dragging: dragging
  };
};

/**
 * @param {Object} dragStart
 * @param {Object} dragging
 * @param {Object} mousePos
 */
export var setDragStart = function setDragStart(dragStart, dragging, mousePos) {
  return {
    type: constants.SET_DRAG_START,
    dragStart: dragStart,
    dragging: dragging,
    mousePos: mousePos
  };
};

/**
 *
 */
export var setDragEnd = function setDragEnd() {
  return {
    type: constants.SET_DRAG_END
  };
};